 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import TEXT02_TITLE_PAGE from '@/components/Text/02_Title_Page'
 import TEXT03_COPYRIGHT_PAGE from '@/components/Text/03_Copyright_Page'
 import TEXT04_CONTENTS from '@/components/Text/04_Contents'
 import TEXT05_LIST_OF_ILLUSTRATIONS from '@/components/Text/05_List_of_illustrations'
 import TEXT06_HOW_TO_USE_THIS_BOOK from '@/components/Text/06_How_to_use_this_book'
 import TEXT07_ASETTING_THE_SCENE from '@/components/Text/07_ASETTING_THE_SCENE'
 import TEXT08_1THE_HISTORICAL_CONTEXT_OF_JESUS from '@/components/Text/08_1The_historical_context_of_Jesus'
 import TEXT09_2JUDAISM_IN_FIRST_CENTURY_PALEST from '@/components/Text/09_2Judaism_in_first_century_Palest'
 import TEXT10_B_APPROACHING_THE_GOSPELS from '@/components/Text/10_B_APPROACHING_THE_GOSPELS'
 import TEXT11_3WHAT_ARE_THE_GOSPELS from '@/components/Text/11_3What_are_the_Gospels'
 import TEXT12_4WHERE_DID_THE_GOSPELS_COME_FROM from '@/components/Text/12_4Where_did_the_Gospels_come_from'
 import TEXT13_5UNDERSTANDING_THE_GOSPELS_TODAY from '@/components/Text/13_5Understanding_the_Gospels_today'
 import TEXT14_C_UNDERSTANDING_JESUS from '@/components/Text/14_C_UNDERSTANDING_JESUS'
 import TEXT15_6THE_QUEST_FOR_THE_HISTORICAL_JE from '@/components/Text/15_6The_quest_for_the_historical_Je'
 import TEXT16_7THE_LIFE_OF_JESUS_IN_THE_LIGHT from '@/components/Text/16_7The_life_of_Jesus_in_the_light'
 import TEXT17_8THE_TEACHING_AND_AIMS_OF_JESUS from '@/components/Text/17_8The_teaching_and_aims_of_Jesus'
 import TEXT18_D_GETTING_INTO_THE_FOUR_GOSPELS from '@/components/Text/18_D_GETTING_INTO_THE_FOUR_GOSPELS'
 import TEXT19_9MARK from '@/components/Text/19_9Mark'
 import TEXT20_10MATTHEW from '@/components/Text/20_10Matthew'
 import TEXT21_11LUKE from '@/components/Text/21_11Luke'
 import TEXT22_12JOHN from '@/components/Text/22_12John'
 import TEXT23_E_THE_ACTS_OF_THE_APOSTLES from '@/components/Text/23_E_THE_ACTS_OF_THE_APOSTLES'
 import TEXT24_13ACTS from '@/components/Text/24_13Acts'
 import TEXT25_GLOSSARY from '@/components/Text/25_Glossary'
 import TEXT26_AUTHOR from '@/components/Text/26_author'
 import TEXT27_MOREIVP from '@/components/Text/27_moreIVP'
 import TEXT28_ATA from '@/components/Text/28_ata'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/04_Contents",
 			"name" : "Text/04_Contents",
 			"component" : TEXT04_CONTENTS
 		},
 		{
 			"path" : "/Text/05_List_of_illustrations",
 			"name" : "Text/05_List_of_illustrations",
 			"component" : TEXT05_LIST_OF_ILLUSTRATIONS
 		},
 		{
 			"path" : "/Text/06_How_to_use_this_book",
 			"name" : "Text/06_How_to_use_this_book",
 			"component" : TEXT06_HOW_TO_USE_THIS_BOOK
 		},
 		{
 			"path" : "/Text/07_ASETTING_THE_SCENE",
 			"name" : "Text/07_ASETTING_THE_SCENE",
 			"component" : TEXT07_ASETTING_THE_SCENE
 		},
 		{
 			"path" : "/Text/08_1The_historical_context_of_Jesus",
 			"name" : "Text/08_1The_historical_context_of_Jesus",
 			"component" : TEXT08_1THE_HISTORICAL_CONTEXT_OF_JESUS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js